module.exports = __webpack_public_path__ + "img/ico_hd_01.859589f8.png";